import {useInvalidateOnAliveUpdate} from '@github-ui/use-invalidate-on-alive-update'
import {timelineQueryKey} from '../page-data/loaders/use-timeline'
import type {PullRequestAliveData} from './use-refetch-on-alive-update'
import {usePullRequestBasePath} from '../stores/layout-selectors'

const filter = (data: PullRequestAliveData) => Boolean(data.event_updates?.timeline_updated)

/** Keeps the timeline panel fresh whenever the server publishes a timeline update. */
export function useTimelineLiveUpdates(channel: string | null | undefined): void {
  const pathName = usePullRequestBasePath()
  // Prefix match, so both sort orders refresh.
  useInvalidateOnAliveUpdate(channel, {queryKey: timelineQueryKey(pathName)}, {filter})
}
